/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'delegations';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'delegation';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'delegation';

/** CoreQueries key for paged/detail OData shapes. */
export const FETCH_PARAMS = 'delegations';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'delegations';

/** Default list sort. */
export const DEFAULT_ORDER_BY = 'number desc';
